var Handlebars, _, capitalize, capitalizeHelper, compare, count, csrf, currencyFormat, datefmt, gettext, jQuery, modifierHeader, numberFormat, percentFormat, registerHelpers, sprintf, statusColor, transformed, ui, urlize, util,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

jQuery = require('jquery');

Handlebars = require('handlebars/runtime');

_ = require('underscore');

capitalize = require('underscore.string/capitalize');

sprintf = (require('sprintf-js')).sprintf;

util = require('evesrp/util');

ui = require('evesrp/common-ui');

csrf = function() {
  var token;
  token = jQuery("meta[name='csrf_token']");
  return token.attr("content");
};

capitalizeHelper = function(str) {
  return capitalize(str);
};

datefmt = function(date, options) {
  var ref, style;
  style = (ref = options.hash.style) != null ? ref : 'medium';
  date = util.localToUTC(date);
  if (style === 'medium') {
    return ui.dateFormatMedium(date);
  } else if (style === 'short') {
    return ui.dateFormatShort(date);
  } else {
    console.log("Invalid datetime style: " + style);
    return ui.dateFormatterMedium(date);
  }
};

currencyFormat = function(currency) {
  if (typeof currency === "string") {
    currency = parseFloat(currency);
  }
  return ui.currencyFormat(currency);
};

numberFormat = function(number) {
  if (typeof number === "string") {
    number = parseFloat(number);
  }
  return ui.numberFormat(number);
};

percentFormat = function(percent) {
  if (typeof number === "string") {
    percent = parseFloat(percent);
  }
  return ui.percentFormat(percent);
};

statusColor = function(status) {
  return util.statusColor(status);
};

compare = function(left, right, options) {
  var call, handlebarsThis, op, ref;
  handlebarsThis = this;
  call = function(bool) {
    if (bool) {
      return options.fn(handlebarsThis);
    } else {
      return options.inverse(handlebarsThis);
    }
  };
  op = (ref = options.hash.operator) != null ? ref : "===";
  switch (op) {
    case "==":
    case "===":
      return call(left === right);
    case "!=":
    case "!==":
      return call(left !== right);
    case "<":
      return call(left < right);
    case ">":
      return call(left > right);
    case "<=":
      return call(left <= right);
    case ">=":
      return call(left >= right);
    case "in":
      return call((indexOf.call(right, left) >= 0));
    case "of":
      return call(left in right);
    default:
      return call(left === right);
  }
};

count = function(collection) {
  return collection.length;
};

gettext = function(msgid, options) {
  var args, escaped, translated;
  translated = ui.i18n.gettext(msgid);
  if (_.isEmpty(options.hash)) {
    escaped = Handlebars.escapeExpression(translated);
    return new Handlebars.SafeString(escaped);
  } else {
    args = _.mapObject(options.hash, Handlebars.escapeExpression);
    return new Handlebars.SafeString(sprintf(translated, args));
  }
};

transformed = function(request, attr) {
  var safeText;
  if (attr in request.transformed) {
    safeText = Handlebars.escapeExpression(request[attr]);
    return new Handlebars.SafeString("<a href=\"" + request.transformed[attr] + "\" target=\"_blank\">" + safeText + " <i class=\"fa fa-external-link\"></i></a>");
  }
  return request[attr];
};

modifierHeader = function(modifier) {
  var amount, escaped, localized;
  if (modifier.type === "absolute") {
    amount = (parseFloat(modifier.value)) / 1000000;
    amount = ui.numberFormat(amount);
    if (modifier.value >= 0) {
      localized = ui.i18n.gettext("%(amount)sM ISK bonus");
    } else {
      localized = ui.i18n.gettext("%(amount)sM ISK penalty");
    }
  } else if (modifier.type === "relative") {
    amount = ui.percentFormat(parseFloat(modifier.value));
    if (modifier.value >= 0) {
      localized = ui.i18n.gettext("%(amount)s bonus");
    } else {
      localized = ui.i18n.gettext("%(amount)s penalty");
    }
  }
  escaped = Handlebars.escapeExpression(sprintf(localized, {
    amount: amount
  }));
  return new Handlebars.SafeString(escaped);
};

urlize = function(str, options) {
  var escaped, limit, ref;
  limit = (ref = options.hash) != null ? ref.limit : void 0;
  escaped = Handlebars.escapeExpression(str);
  return new Handlebars.SafeString(util.urlize(escaped, limit));
};

registerHelpers = function(handlebars) {
  handlebars.registerHelper({
    attr_gettext: ui.attributeGettext,
    csrf: csrf,
    capitalize: capitalizeHelper,
    currencyfmt: currencyFormat,
    numberfmt: numberFormat,
    percentfmt: percentFormat,
    datefmt: datefmt,
    status_color: statusColor,
    compare: compare,
    count: count,
    transformed: transformed,
    gettext: gettext,
    modifier_header: modifierHeader,
    urlize: urlize
  });
  return handlebars;
};

exports.registerHelpers = registerHelpers;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
